module.exports = __webpack_public_path__ + "static/media/sylized_8.e648ab35.svg";